import { calendarAvailabilityConstants } from "../../_constants";

const initialState = {};

// mentor event details
export const get_calendar_availability_details_data_reducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case calendarAvailabilityConstants.GET_CALENDAR_AVAILABILITY_DETAILS_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case calendarAvailabilityConstants.GET_CALENDAR_AVAILABILITY_DETAILS_ACTION_SUCCESS:
    case calendarAvailabilityConstants.CREATE_CALENDAR_AVAILABILITY_ACTION_SUCCESS:
    case calendarAvailabilityConstants.UPDATE_CALENDAR_AVAILABILITY_ACTION_SUCCESS:
      return {
        type: "alert-success",
        calendarAvailabilityData: action.payload,
      };
    case calendarAvailabilityConstants.GET_CALENDAR_AVAILABILITY_DETAILS_ACTION_FAILURE:
      return {
        type: "alert-failure",
        message: action.payload,
      };
    default:
      return state;
  }
};

// mentor event details
export const get_calendar_availability_lists_data_reducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case calendarAvailabilityConstants.GET_CALENDAR_AVAILABILITY_LISTS_ACTION_REQUEST:
      return {
        type: "alert-success",
        message: action.payload,
      };
    case calendarAvailabilityConstants.GET_CALENDAR_AVAILABILITY_LISTS_ACTION_SUCCESS:
      return {
        type: "alert-success",
        calendarAvailabilityListsData: action.payload,
      };
    case calendarAvailabilityConstants.GET_CALENDAR_AVAILABILITY_LISTS_ACTION_FAILURE:
      return {
        type: "alert-failure",
        message: action.payload,
      };
    default:
      return state;
  }
};
